var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { Card } from '../card';
import { NotificationIcon } from '../notification-icon';
import CloseButton from './close-button';
import { contentStyle, notificationStyle } from './styles';
var decorHighlightVariantMap = {
    error: 'red',
    info: 'blue',
    success: 'green',
    upgrade: 'purple',
    warning: 'orangeLight',
};
function NotificationCardInternal(_a, ref) {
    var children = _a.children, _b = _a.closable, closable = _b === void 0 ? false : _b, closeButtonOverride = _a.closeButtonOverride, _c = _a.hideLeftDecor, hideLeftDecor = _c === void 0 ? false : _c, _d = _a.isContentCentered, isContentCentered = _d === void 0 ? false : _d, onClose = _a.onClose, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.variant, variant = _f === void 0 ? 'info' : _f, restProps = __rest(_a, ["children", "closable", "closeButtonOverride", "hideLeftDecor", "isContentCentered", "onClose", "size", "variant"]);
    function renderCloseButton() {
        function handleClick() {
            var _a, _b;
            (_b = closeButtonOverride === null || closeButtonOverride === void 0 ? void 0 : (_a = closeButtonOverride.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        if (closable) {
            return closeButtonOverride != null ? (
            // TODO: Replace cloning with context during future refactor - ixTec
            cloneElement(closeButtonOverride, {
                onClick: handleClick,
                size: size,
            })) : (_jsx(CloseButton, __assign({}, { size: size }, { onClick: onClose })));
        }
        return null;
    }
    return (_jsxs(Card, __assign({ css: notificationStyle({ variant: variant }), disableHoverEffect: true, ref: ref, role: "status" }, (!hideLeftDecor && {
        highlightVariant: decorHighlightVariantMap[variant],
        variant: 'highlight',
    }), __assign({ size: size }, restProps), { children: [_jsx(NotificationIcon, __assign({}, {
                isCentered: isContentCentered && closable,
                size: size,
                variant: variant,
            })), _jsx("div", __assign({ css: contentStyle({ closable: closable, isContentCentered: isContentCentered }) }, { children: children })), renderCloseButton()] })));
}
export default NotificationCardInternal;
